import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Image, Tab, Dropdown, Input, Popup, Modal, Icon, ModalContent, ModalDescription, TextArea, Form, ModalHeader, ModalActions } from "semantic-ui-react";
import { pgtoWebListAction } from '../../actions/PgtoWebActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';


const Container = styled.div`
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    padding: 24px;
    font-family: "Inter", sans-serif;
  `;

const FiltrosContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 16px;
    align-items: end;
    margin-bottom: 24px;
  `;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    th {
      text-align: left;
      font-weight: 600;
      color: #555;
      padding: 12px 8px;
      border-bottom: 1px solid #eee;
    }

    td {
      padding: 12px 8px;
      font-size: 0.95rem;
      color: #333;
      border-bottom: 1px solid #f3f3f3;
    }

    td:nth-child(7),
    td:nth-child(8),
    td:nth-child(9),
    th:nth-child(7),
    th:nth-child(8),
    th:nth-child(9) {
      text-align: center;
    }

    tr:hover td {
      background: #fafafa;
    }
  `;

const Status = styled.span`
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  max-width: 150px; /* limite máximo de largura antes de quebrar a linha */
  display: inline-block; /* necessário para respeitar o max-width */
  white-space: normal; /* permite quebra de linha */
  word-wrap: break-word; /* quebra palavras longas se necessário */
  background: ${({ $status }) =>
    $status === "Capturado"
      ? "rgba(46, 204, 113, 0.1)"       // verde pastel
      : $status === "Estornado"
        ? "rgba(230, 126, 34, 0.15)"    // laranja mais forte, mas suave
        : $status === "Aprovado Aguardando Captura/Estorno"
          ? "rgba(241, 196, 15, 0.1)"   // amarelo pastel
          : "rgba(231, 76, 60, 0.1)"};  // vermelho pastel

color: ${({ $status }) =>
    $status === "Capturado"
      ? "#27ae60"                        // verde
      : $status === "Estornado"
        ? "#d35400"                      // laranja mais forte
        : $status === "Aprovado Aguardando Captura/Estorno"
          ? "#f39c12"                    // amarelo
          : "#e74c3c"};                  // vermelho
                 // vermelho
`;


const CustomInput = styled(Input)`
    input:focus {
    border-color: #102E3E !important;
    box-shadow: 0 0 0 1px #102E3E !important;
  }

  /* Remove os botões de incremento/decremento do type=number */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  `;

const CustomDropdown = styled(Dropdown)`
    &.ui.selection.dropdown:focus,
    &.ui.selection.dropdown.active {
      border-color: #102E3E !important;
      box-shadow: 0 0 0 1px #102E3E !important;
    }

    &.ui.selection.dropdown.active .dropdown.icon {
      color: #102E3E !important;
    }

    &.ui.selection.dropdown .menu {
      border: 2px solid #102E3E !important;
      border-radius: 4px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
    }
  `;

function ListaTransacao(props) {

  const { pgtoWebListAction } = props;

  const { isloading, pgtoweblist, vendedorvcc } = props;

  const [filtros, setFiltros] = useState({
    status: "",
    parceiro: "",
    nota: "",
    vendedor: vendedorvcc ?? "",
    dataInicio: "",
    dataFim: "",
  });
  const [open, setOpen] = useState(false);
  const [transacaoSelecionada, setTransacaoSelecionada] = useState(null);
  const [senhaAcesso, setSenhaAcesso] = useState('');

  useEffect(() => {
    console.log("VENDEDOR ->", vendedorvcc);

    const novosFiltros = {
      status: null,
      parceiro: "",
      nota: "",
      vendedor:
        vendedorvcc === null || vendedorvcc === "null" ? "" : vendedorvcc,
      dataInicio: "",
      dataFim: "",
    };

    console.log("FILTROS ->", novosFiltros);
    setFiltros(novosFiltros);
    pgtoWebListAction(novosFiltros);
  }, [vendedorvcc]);





  const statusOptions = [
    { key: "todos", text: "Todos", value: "todos" },
    { key: "capturado", text: "Capturado", value: "Capturado" },
    { key: "negado", text: "Negado", value: "Negado" },
    { key: "estornado", text: "Estornado", value: "Estornado" },
    { key: "aprovado", text: "Aprovado Aguardando Captura/Estorno", value: "Aprovado Aguardando Captura/Estorno" },
  ];

  const handleChange = (e, { name, value }) => {
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleBuscar = () => {
    pgtoWebListAction(filtros);
    console.log("Filtros aplicados:", filtros);
  };

  const handleOpenModal = (id) => {
    const encontrada = pgtoweblist.find(t => t.transacaoid === id);
    setTransacaoSelecionada(encontrada);
    setOpen(true);

    const mensagem = encontrada.senha;

    const match = mensagem.match(/<b>Senha de Acesso:<\/b>\s*([A-Za-z0-9]+)/);

    const matchplus = mensagem.match(/<b>Senha de Acesso<\/b>\s*([A-Za-z0-9]+)/);


    const senha = match ? match[1] : matchplus ? matchplus[1] : 'Não encontrada';

    setSenhaAcesso(senha);
  };


  const getCardBrandImage = (type) => {
    switch (type) {
      case "Visa":
        return "/img/pgtoweb-cartoes/visa.png";
      case "Mastercard":
        return "/img/pgtoweb-cartoes/mastercard.png";
      case "Hipercard":
        return "/img/pgtoweb-cartoes/hipercard.png";
      case "Maestro":
        return "/img/pgtoweb-cartoes/maestro.png";
      case "Elo":
        return "/img/pgtoweb-cartoes/elo.png";
      case "Amex":
        return "/img/pgtoweb-cartoes/amex.png";
      case "Diners":
        return "/img/pgtoweb-cartoes/diners.png";
      default:
        return "/img/pgtoweb-cartoes/mastercard.png";
    }
  };

  return (
    <Tab.Pane loading={isloading}>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >

        <ModalHeader>TransacaoID({transacaoSelecionada?.transacaoid}) NuNota({transacaoSelecionada?.nunota})</ModalHeader>
        <ModalContent image scrolling>
          <ModalDescription>

            <>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 50%', padding: '10px' }}>
                  <section>
                    <h3>Informações do Devedor</h3>
                    <span><strong>Razão Social:</strong> {transacaoSelecionada?.razaosocial}</span><br></br>
                    <span><strong>Codigo Parceiro:</strong> {transacaoSelecionada?.codparc}</span><br></br>
                    <span><strong>Senha de acesso:</strong> {senhaAcesso}</span><br></br>
                  </section>
                  <hr></hr>
                  <section>
                    <h3>Informações do Vendedor</h3>
                    <span><strong>Cod Vendedor:</strong> {transacaoSelecionada?.codvend}</span><br></br>
                    <span><strong>Nome Vendedor:</strong> {transacaoSelecionada?.vendedor}</span><br></br>
                  </section>
                  <hr></hr>
                  <section>
                    <h3>Detalhes da Transação</h3>
                    <span><strong>Transação ID:</strong> {transacaoSelecionada?.transacaoid}</span><br></br>
                    <span><strong>Nunota:</strong> {transacaoSelecionada?.nunota}</span><br></br>
                    <span><strong>Data da transação:</strong> {moment(transacaoSelecionada?.datatransacao).format('DD/MM/YYYY HH:mm')}</span><br></br>
                    <span><strong>Status da Transação:</strong>
                      <span style={{
                        color: transacaoSelecionada?.statustransacao === "Capturado"
                          ? "#27ae60"                        // verde
                          : transacaoSelecionada?.statustransacao === "Estornado"
                            ? "#d35400"                      // laranja mais forte
                            : transacaoSelecionada?.statustransacao === "Aprovado Aguardando Captura/Estorno"
                              ? "#f39c12"                    // amarelo
                              : "#e74c3c"
                      }}> {transacaoSelecionada?.statustransacao}</span>
                    </span><br></br>
                    <span><strong>Descrição:</strong> <span style={{
                      color: transacaoSelecionada?.descricao === "Transação autorizada com sucesso."
                        ? "#27ae60"                        // verde
                        : "#e74c3c"
                    }}> {transacaoSelecionada?.descricao}</span></span><br></br>
                    <span><strong>Valor:</strong> {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(transacaoSelecionada?.valor)}</span><br></br>
                    <span><strong>Transação_TID:</strong> {transacaoSelecionada?.tid}</span><br></br>
                    <span><strong>Transação_NSU:</strong> {transacaoSelecionada?.nsu}</span><br></br>
                  </section>
                  <hr></hr>
                  {vendedorvcc === 'null' && (
                    <section>
                      <p><strong>Transação API Enviado:</strong></p>
                      <Form>
                        <TextArea>{transacaoSelecionada?.enviado}</TextArea>
                        <p><strong>Transação API Recebido:</strong></p>
                        <TextArea>{transacaoSelecionada?.recebido}</TextArea>
                      </Form>
                      <Form>
                        {transacaoSelecionada?.estornoenviado_transacao && (
                          <>
                            <p><strong>Estorno Transação Enviado:</strong></p>
                            <TextArea>{transacaoSelecionada?.estornoenviado_transacao}</TextArea>
                          </>
                        )}
                        {transacaoSelecionada?.estornorecebido_transacao && (
                          <>
                            <p><strong>Estorno Transação Recebido:</strong></p>
                            <TextArea>{transacaoSelecionada?.estornorecebido_transacao}</TextArea>

                          </>
                        )}
                      </Form>
                    </section>
                  )}
                </div>


                <div style={{ flex: '1 1 50%', padding: '10px' }}>
                  <section>
                    <h3>Detalhes da Verificação</h3>
                    <span><strong>Verificação ID:</strong> {transacaoSelecionada?.verificacao_paymentid}</span><br></br>
                    <span><strong>Data da verificação:</strong> {transacaoSelecionada?.dt_verificado ? moment(transacaoSelecionada?.dt_verificado).format('DD/MM/YYYY HH:mm') : ''}</span><br></br>
                    <span><strong>Status da Verificação:</strong>
                      <span style={{
                        color: transacaoSelecionada?.transacao_status_text_verificacao === "Transacao autorizada"
                          ? "#27ae60"                        // verde
                          : "#e74c3c"
                      }}>   {transacaoSelecionada?.transacao_status_text_verificacao} </span></span><br></br>
                    <span><strong>Verificado:</strong> {transacaoSelecionada?.isverificado === 0 ? 'Não' : transacaoSelecionada?.isverificado === 1 ? 'Sim' : '-'}</span><br></br>
                    <span><strong>Valor Digitado:</strong> {transacaoSelecionada?.vlr_digitado ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(transacaoSelecionada?.vlr_digitado) : '-'}</span><br></br>
                    <span><strong>Quantidade de tentativas de verificação:</strong> {transacaoSelecionada?.qtd_tentativas}</span><br></br>
                    <span><strong>Verificação_TID:</strong> {transacaoSelecionada?.verificacao_tid}</span><br></br>
                    <span><strong>Verificação_NSU:</strong> {transacaoSelecionada?.verificacao_nsu}</span><br></br>
                    <span><strong>Data Estorno:</strong> {transacaoSelecionada?.estorno_dt_verificacao ? moment(transacaoSelecionada?.estorno_dt_verificacao).format('DD/MM/YYYY HH:mm') : ''}</span><br></br>
                  </section>
                  <hr></hr>
                  {vendedorvcc === 'null' && (
                    <section>
                      <Form>
                        {transacaoSelecionada?.enviado_verificacao && (
                          <>
                            <p><strong>Verificação API Enviado:</strong></p>
                            <TextArea>{transacaoSelecionada?.enviado_verificacao}</TextArea>
                          </>
                        )}
                        {transacaoSelecionada?.recebido_verificacao && (
                          <>
                            <p><strong>Verificação API Recebido:</strong></p>
                            <TextArea>{transacaoSelecionada?.recebido_verificacao}</TextArea>
                          </>
                        )}
                        {transacaoSelecionada?.estorno_enviado_verificacao && (
                          <>
                            <p><strong>Estorno Verificação API Enviado:</strong></p>
                            <TextArea>{transacaoSelecionada?.estorno_enviado_verificacao}</TextArea>
                          </>
                        )}
                        {transacaoSelecionada?.estorno_recebido_verificacao && (
                          <>
                            <p><strong>Estorno Verificação API Recebido:</strong></p>
                            <TextArea>{transacaoSelecionada?.estorno_recebido_verificacao}</TextArea>
                          </>
                        )}
                      </Form>
                    </section>
                  )}
                </div>
              </div>

            </>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button onClick={() => setOpen(false)} color='red'>
            Fechar  <Icon name='cancel' />
          </Button>
        </ModalActions>

      </Modal>
      <Container>
        {/* Filtros de Busca */}
        <FiltrosContainer>
          <CustomDropdown
            placeholder="Status"
            fluid
            selection
            clearable
            options={statusOptions}
            name="status"
            value={filtros.status === "" ? "todos" : filtros.status}
            onChange={(e, { value }) =>
              handleChange(e, { name: "status", value: value === "todos" ? "" : value })
            }
          />

          <CustomInput
            placeholder="Código do Parceiro"
            name="parceiro"
            value={filtros.parceiro}
            onChange={handleChange}
            fluid
            type="number"
          />

          <CustomInput
            placeholder="Número da Nota"
            name="nota"
            value={filtros.nota}
            onChange={handleChange}
            fluid
            type="number"
          />

          <CustomInput
            type="date"
            name="dataInicio"
            value={filtros.dataInicio}
            onChange={handleChange} // aqui o Semantic UI já fornece {name, value}
            fluid
          />

          <CustomInput
            type="date"
            name="dataFim"
            value={filtros.dataFim}
            onChange={handleChange}
            fluid
          />

          <Button
            icon="search"
            content="Buscar"
            onClick={handleBuscar}
            style={{ height: "40px", backgroundColor: "#102E3E", color: "#fff" }}
          />
        </FiltrosContainer>
        <Table>
          <thead>
            <tr>
              <th>Nunota</th>
              <th>Codparc</th>
              <th>Razão social</th>
              <th>Vendedor</th>
              <th>Status</th>
              <th>Cartão</th>
              <th>Número do cartão</th>
              <th>Valor</th>
              <th><p >TID /</p>Autorização / NSU</th>
              <th>Data da transação</th>
              <th>Mais Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {pgtoweblist.map((item) => (
              <tr key={item.transacaoid}>
                <td>{item.nunota}</td>
                <td>{item.codparc}</td>
                <td>{item.razaosocial}</td>
                <td>{item.vendedor}</td>
                <td>
                  <Status $status={item.statustransacao}>{item.statustransacao}</Status>
                </td>
                <td>
                  <div style={{ display: 'flex' }}><Image
                    src={getCardBrandImage(item.bandeira)}
                    size="mini"
                    style={{ width: 28, height: "auto", marginLeft: 10 }}
                    alt={item.bandeira}
                  /><Popup content={item.isverificado == 1 && `Cartão verificado em: ${moment(item.dt_verificado).format('DD/MM/YYYY HH:mm')} em ${item.qtd_tentativas}  tentativa(s). Valor digitado: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.vlr_digitado)}`}
                    trigger={<p style={{ cursor: 'pointer', color: 'green' }}>{item.isverificado == 1 && '✔'}</p>} /></div>
                </td>
                <td>
                  {/* <Popup content={item.item.nometitularcartao}
                    trigger={<div>{item.numerocartaomascarado}</div>} /> */}
                  {item.numerocartaomascarado === '0' ? '-' :
                    <div>
                      {item.numerocartaomascarado} <br />
                      {item.nometitularcartao}
                    </div>
                  }
                </td>
                <td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor)}</td>
                <td>{item.tid}  {item.authorizationcode && 'Aut:' + item.authorizationcode} {item.nsu && 'NSU:' + item.nsu}</td>
                <td>
                  <div style={{ display: 'flex', textAlign: 'center' }}>
                    {moment(item.datatransacao).format('DD/MM/YYYY HH:mm')}

                    <Popup
                      content={
                        item.transacao_status_text_verificacao == null ? (
                          <>
                            Valor de Verificação: Transacao autorizada
                            {item.estorno_verificacao && item.estorno_dt_verificacao && (
                              <>
                                <br />
                                Estorno: {item.estorno_verificacao}{' '}
                                {moment(item.estorno_dt_verificacao).format('DD/MM/YYYY HH:mm')}
                              </>
                            )}
                          </>
                        ) : item.transacao_status_verificacao == 1 ? (
                          <>
                            Valor de Verificação: {item.transacao_status_text_verificacao}
                            {item.estorno_verificacao && item.estorno_dt_verificacao ? (
                              <>
                                <br />
                                Estorno: {item.estorno_verificacao}{' '}
                                {moment(item.estorno_dt_verificacao).format('DD/MM/YYYY HH:mm')}
                              </>
                            ) : (
                              <><br />
                                Aguardando o cliente verificar o cartão...
                              </>

                            )}
                          </>
                        ) : (
                          item.transacao_status_text_verificacao
                        )
                      }
                      trigger={
                        <p style={{ cursor: 'pointer', color: 'green' }}>
                          {item.transacao_status_verificacao === 1 ? '✔' : '❌'}
                        </p>
                      }
                    />
                  </div>
                </td>

                <td>
                  <Button
                    style={{ backgroundColor: "#32CD69", color: "#fff" }}
                    size="tiny"
                    onClick={() => handleOpenModal(item.transacaoid)}
                  >
                    Ver mais
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </Tab.Pane>
  );
}

const mapStateToProps = (state) => ({
  pgtoweblist: state.PgtoWebReducer.pgtoweblist,
  isloading: state.PgtoWebReducer.isloading,
  vendedorvcc: state.LoginReducer.vendedorvcc
})
export default withRouter(connect(mapStateToProps, {
  pgtoWebListAction
}
)(ListaTransacao));
